import IconCard from 'components/iconCard/IconCard'
import React, { useEffect } from 'react'
import Image from 'react-bootstrap/Image'
import { connect, useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import images from 'resources/assets/images'
import I18n from 'resources/i18n/I18n'
import { resetFilters } from '../../store/actions/searchActions'
import './home.scss'

const Home = () => {
  const dispatch = useDispatch()
  const currentUser = useSelector((state) => state.userReducer.user)
  const history = useHistory()

  useEffect(() => {
    dispatch(resetFilters())
  }, [dispatch])

  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <Image className="logo" src={images.homeLogo} />
      </div>
      <div className="row justify-content-center row-container">
        <IconCard
          onClick={() => {
            history.push('/signalement', { from: '/accueil' })
          }}
          iconType="icon-warning"
          title={I18n.t('HomeScreenTitleReport')}
          description={I18n.t('HomeScreenDescriptionReport')}
        />
        <IconCard
          onClick={() => {
            history.push('/consulter')
          }}
          iconType="icon-pictoSearch"
          title={I18n.t('HomeScreenTitleSearch')}
          description={I18n.t('HomeScreenDescriptionSearch')}
          displayNotification
        />
        <IconCard
          onClick={() => {
            history.push('/statistiques')
          }}
          iconType="icon-bar-chart"
          title={I18n.t('HomeScreenTitleStats')}
          description={I18n.t('HomeScreenDescriptionStats')}
        />
        <IconCard
          onClick={() => {
            history.push('/aide')
          }}
          iconType="icon-help"
          title={I18n.t('HomeScreenTitleHelp')}
          description={I18n.t('HomeScreenDescriptionHelp')}
        />
        {currentUser.roles && currentUser.roles.indexOf('ORFI-ADMIN') > -1 && (
          <IconCard
            onClick={() => {
              history.push('/configuration')
            }}
            iconType="icon-settings"
            title={I18n.t('HomeScreenTitleConfiguration')}
            description={I18n.t('HomeScreenDescriptionConfiguration')}
          />
        )}
        {currentUser.roles && currentUser.roles.indexOf('ORFI-GESTIONNAIRE') > -1 && (
          <IconCard
            onClick={() => {
              history.push('/organismes')
            }}
            iconType="icon-settings"
            title={I18n.t('HomeScreenTitleOrganismes')}
            description={I18n.t('HomeScreenDescriptionOrganismes')}
          />
        )}
      </div>
    </div>
  )
}

export default connect()(Home)
